import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-primary" }
const _hoisted_2 = { class: "flex flex-col text-white mb-12 md:mb-0" }
const _hoisted_3 = ["href", "aria-label"]
const _hoisted_4 = { class: "md:flex md:flex-col md:justify-between" }
const _hoisted_5 = { class: "mb-12 text-white" }
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = { class: "mr-0 md:mr-4" }
const _hoisted_8 = { class: "flex text-white md:justify-end" }
const _hoisted_9 = ["href", "aria-label"]
const _hoisted_10 = { class: "hidden" }
const _hoisted_11 = ["href", "aria-label"]
const _hoisted_12 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Section = _resolveComponent("Section")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Section, { class: "md:flex md:justify-between md:items-stretch" }, {
            default: _withCtx(() => [
              _createElementVNode("nav", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: link.label,
                    href: link.href,
                    class: "mb-4 last:mb-0 hover:text-gray w-fit flex animate-underline-thin-tertiary",
                    "aria-label": link.aria
                  }, _toDisplayString(link.label), 9, _hoisted_3))
                }), 128))
              ]),
              _createElementVNode("aside", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: _ctx.$t('contact.email.url'),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "flex md:flex-row-reverse items-center w-fit hover:text-gray animate-underline-thin-tertiary",
                    "aria-label": _ctx.$t('contact.email.aria')
                  }, [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: "fa-solid fa-envelope",
                      class: "mr-4 md:mr-0"
                    }),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("contact.email.label")), 1)
                  ], 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    href: _ctx.$t('contact.linkedin.url'),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "hover:text-gray mr-4",
                    "aria-label": _ctx.$t('contact.linkedin.aria')
                  }, [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: "fa-brands fa-linkedin",
                      size: "2x"
                    }),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("contact.linkedin.label")), 1)
                  ], 8, _hoisted_9),
                  _createElementVNode("a", {
                    href: _ctx.$t('contact.github.url'),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "hover:text-gray",
                    "aria-label": _ctx.$t('contact.github.aria')
                  }, [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: "fa-brands fa-github",
                      size: "2x"
                    }),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("contact.github.label")), 1)
                  ], 8, _hoisted_11)
                ])
              ])
            ]),
            _: 1
          }),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-white text-center pb-4 text-sm" }, [
            _createElementVNode("p", null, "© 2025 Karol Jaskółka")
          ], -1))
        ]),
        _: 1
      })
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-16 lg:h-0 bg-primary" }, null, -1))
  ], 64))
}